export default "__VITE_ASSET__zP9_5c4x__"